import { Spinner } from "react-bootstrap";
import Drawer from "../../../../components/Drawer";
import { useState } from "react";
// import NumberFormat from "react-number-format";

const NewReserveFoodDrawer = ({
  setAddNew,
  setOpenDrawer,
  handleUserSubmit,
  user,
  openDrawer,
  selectImageNewUser,
  handleUserChange,
  showPassword,
  show,
  EyeOpen,
  EyeBlock,
  showConfirmPassword,
  showConfirm,
  loadBtn,
  setRegexPassword,
}) => {
  const regexPasswordError =
    "As senhas devem ter no mínimo 8 caracteres contendo uma letra, um número e um caracter especial";
  const [password, setPassword] = useState(() => user.password);

  function validarSenha(event) {
    const regex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+={[}\]|\\:;"'<,>.?/-]).{8,}$/;
    let pw = regex.test(event.target.value);
    setRegexPassword(pw);
    if (pw) {
      handleUserChange(event);
    }
  }
  return (
    <Drawer
      show={openDrawer}
      onClose={() => {
        setOpenDrawer(false);
        setPassword("");
      }}
    >
      <form style={{ maxHeight: "100%" }}>
        <div className="d-flex col align-items-center">
          <span className="text-cl-black ff-univanova-medium fz-20 mb-4 me-auto">
            {user._id === undefined || user._id === null ? "Adicionar Colaborador" : "Editar Colaborador"}
          </span>
        </div>
        <div className="d-flex flex-column">
          <form onSubmit={handleUserSubmit}>
            <div className="row">
              {user._id === undefined || user._id === null ? (
                <>
                  <div className="d-flex justify-content-center">
                    {!user.avatar ? (
                      <label
                        htmlFor="fileNewUser"
                        className="bg-cl-chinese-white d-flex justify-content-center align-items-center flex-column c-pointer "
                        style={{
                          height: "160px",
                          width: "160px",
                          borderRadius: "50%",
                        }}
                      >
                        <i className="bi bi-plus-circle fa-2x text-cl-philippine-silver"></i>
                        <span className="text-cl-philippine-silver ff-univanova-medium fz-16">Adicionar foto</span>
                        <input
                          type="file"
                          id="fileNewUser"
                          onChange={(e) => selectImageNewUser(e)}
                          className="d-none"
                        />
                      </label>
                    ) : (
                      <label
                        htmlFor="fileNewUser"
                        className="d-flex justify-content-center align-items-center flex-column c-pointer "
                        style={{
                          height: "160px",
                          width: "160px",
                          borderRadius: "50%",
                        }}
                      >
                        <img src={user.avatar} className="w-100 h-100" alt="" style={{ borderRadius: "50%" }} />
                        <input
                          type="file"
                          id="fileNewUser"
                          onChange={(e) => selectImageNewUser(e)}
                          className="d-none"
                        />
                      </label>
                    )}
                  </div>
                  <div className="col-12 mt-2 mt-lg-3 mb-2">
                    <label className="form-label ff-univanova-bold text-cl-arsenic-2 fz-16 mb-1">Nome:</label>
                    <input
                      type="text"
                      name="name"
                      value={user.name}
                      onChange={(e) => handleUserChange(e)}
                      className="form-control"
                      placeholder="Digite o nome"
                      required
                    />
                  </div>
                  <div className="col-12 mt-2 mt-lg-3 mb-2">
                    <label className="form-label ff-univanova-bold text-cl-arsenic-2 fz-16 mb-1">Celular:</label>
                    <input
                      type="tel"
                      name="phone"
                      placeholder="(XX)99999-9999"
                      value={user.phone}
                      onChange={(e) => handleUserChange(e)}
                      className="form-control"
                      required
                    />
                  </div>
                  <div className="col-12 mt-2 mb-2">
                    <label className="form-label ff-univanova-bold text-cl-arsenic-2 fz-16 mb-1">Email:</label>
                    <input
                      type="email"
                      name="email"
                      value={user.email}
                      onChange={(e) => handleUserChange(e)}
                      className="form-control"
                      placeholder="Digite o email"
                      required
                    />
                  </div>
                  <div className="col-12 mt-2">
                    <label className="form-label ff-univanova-bold text-cl-arsenic-2 fz-16 mb-1">Senha:</label>
                    <div className="eye-component d-flex mb-2">
                      <input
                        style={{
                          borderTop: "1px solid #E0E0E0",
                          borderLeft: "1px solid #E0E0E0",
                          borderBottom: "1px solid #E0E0E0",
                          borderRight: "0px solid transparent",
                          borderRadius: "5px 0px 0px 5px",
                        }}
                        name="password"
                        value={password}
                        onChange={(e) => {
                          setPassword(e.target.value);
                          validarSenha(e);
                        }}
                        type={showPassword ? "text" : "password"}
                        placeholder="Digite a senha"
                        className="password form-control px-2 w-90"
                        required
                      />
                      <button
                        onClick={(event) => show(event)}
                        style={{
                          backgroundColor: "transparent",
                          borderTop: "1px solid #E0E0E0",
                          borderRight: "1px solid #E0E0E0",
                          borderBottom: "1px solid #E0E0E0",
                          borderLeft: "0px solid transparent",
                          borderRadius: "0px 5px 5px 0px",
                        }}
                      >
                        <img
                          alt=""
                          width={"24px"}
                          height={"24px"}
                          className=" w-auto"
                          src={showPassword ? EyeOpen : EyeBlock}
                        />
                      </button>
                    </div>
                  </div>
                  <div className="col-12">
                    <label className="form-label ff-univanova-bold text-cl-arsenic-2 fz-16 mb-1">
                      Confirmar senha:
                    </label>
                    <div className="eye-component d-flex mb-16">
                      <input
                        style={{
                          borderTop: "1px solid #E0E0E0",
                          borderLeft: "1px solid #E0E0E0",
                          borderBottom: "1px solid #E0E0E0",
                          borderRight: "0px solid transparent",
                          borderRadius: "5px 0px 0px 5px",
                          height: "38px",
                        }}
                        name="confirmPassword"
                        value={user.confirmPassword}
                        onChange={(e) => handleUserChange(e)}
                        type={showConfirmPassword ? "text" : "password"}
                        placeholder="Confirme a senha"
                        className="password form-control  px-2 w-90"
                        required
                      />
                      <button
                        onClick={(event) => showConfirm(event)}
                        style={{
                          backgroundColor: "transparent",
                          borderTop: "1px solid #E0E0E0",
                          borderRight: "1px solid #E0E0E0",
                          borderBottom: "1px solid #E0E0E0",
                          borderLeft: "0px solid transparent",
                          borderRadius: "0px 5px 5px 0px",
                        }}
                      >
                        <img
                          alt=""
                          width={"24px"}
                          height={"24px"}
                          className=" w-auto"
                          src={showConfirmPassword ? EyeOpen : EyeBlock}
                        />
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="d-flex justify-content-center">
                    {user.avatar === undefined || user.avatar === null ? (
                      <label
                        htmlFor="fileNewUser"
                        className="bg-cl-chinese-white d-flex text-cl-philippine-silver justify-content-center align-items-center flex-column c-pointer "
                        style={{
                          height: "160px",
                          width: "160px",
                          borderRadius: "50%",
                        }}
                      >
                        <i className="bi bi-plus-circle fa-2x"></i>
                        <span className="text-cl-philippine-silver ff-univanova-medium fz-16">Adicionar foto</span>
                        <input
                          type="file"
                          id="fileNewUser"
                          onChange={(e) => selectImageNewUser(e)}
                          className="d-none"
                        />
                      </label>
                    ) : (
                      <label
                        htmlFor="fileNewUser"
                        className="d-flex justify-content-center align-items-center flex-column c-pointer "
                        style={{
                          height: "160px",
                          width: "160px",
                          borderRadius: "50%",
                        }}
                      >
                        <img src={user.avatar} className="w-100 h-100" alt="" style={{ borderRadius: "50%" }} />
                        <input
                          type="file"
                          id="fileNewUser"
                          onChange={(e) => selectImageNewUser(e)}
                          className="d-none"
                        />
                      </label>
                    )}
                  </div>
                  <div className="col-12 mt-2 mt-lg-3 mb-2">
                    <label className="form-label ff-univanova-bold text-cl-arsenic-2 fz-16 mb-1">Nome:</label>
                    <input
                      type="text"
                      name="name"
                      value={user.name}
                      onChange={(e) => handleUserChange(e)}
                      className="form-control"
                      placeholder="Digite o nome"
                      required
                    />
                  </div>
                  <div className="col-12 mt-2 mt-lg-3 mb-2">
                    <label className="form-label ff-univanova-bold text-cl-arsenic-2 fz-16 mb-1">Celular:</label>
                    <input
                      type="tel"
                      name="phone"
                      value={user.phone}
                      onChange={(e) => handleUserChange(e)}
                      className="form-control"
                      placeholder="Digite o celular Ex: (DD)000000000"
                      maxLength="11"
                      pattern="[0-9]{11}"
                      required
                    />
                  </div>
                  <div className="col-12 mt-2 mb-2">
                    <label className="form-label ff-univanova-bold text-cl-arsenic-2 fz-16 mb-1">Email:</label>
                    <input
                      type="email"
                      name="email"
                      value={user.email}
                      onChange={(e) => handleUserChange(e)}
                      className="form-control"
                      placeholder="Digite o email"
                      required
                    />
                  </div>
                  <div className="col-12 mt-2">
                    <label className="form-label ff-univanova-bold text-cl-arsenic-2 fz-16 mb-1">Senha:</label>
                    <div className="eye-component d-flex mb-2">
                      <input
                        style={{
                          borderTop: "1px solid #E0E0E0",
                          borderLeft: "1px solid #E0E0E0",
                          borderBottom: "1px solid #E0E0E0",
                          borderRight: "0px solid transparent",
                          borderRadius: "5px 0px 0px 5px",
                        }}
                        name="password"
                        value={password}
                        onChange={(e) => {
                          setPassword(e.target.value);
                          validarSenha(e);
                        }}
                        type={showPassword ? "text" : "password"}
                        placeholder="Digite a senha"
                        className="password form-control px-2 w-90"
                        required
                      />
                      <button
                        onClick={(event) => show(event)}
                        style={{
                          backgroundColor: "transparent",
                          borderTop: "1px solid #E0E0E0",
                          borderRight: "1px solid #E0E0E0",
                          borderBottom: "1px solid #E0E0E0",
                          borderLeft: "0px solid transparent",
                          borderRadius: "0px 5px 5px 0px",
                        }}
                      >
                        <img
                          alt=""
                          width={"24px"}
                          height={"24px"}
                          className=" w-auto"
                          src={showPassword ? EyeOpen : EyeBlock}
                        />
                      </button>
                    </div>
                  </div>
                  <div className="col-12">
                    <label className="form-label ff-univanova-bold text-cl-arsenic-2 fz-16 mb-1">
                      Confirmar senha:
                    </label>
                    <div className="eye-component d-flex mb-16">
                      <input
                        style={{
                          borderTop: "1px solid #E0E0E0",
                          borderLeft: "1px solid #E0E0E0",
                          borderBottom: "1px solid #E0E0E0",
                          borderRight: "0px solid transparent",
                          borderRadius: "5px 0px 0px 5px",
                          height: "38px",
                        }}
                        name="confirmPassword"
                        onChange={(e) => handleUserChange(e)}
                        type={showConfirmPassword ? "text" : "password"}
                        placeholder="Confirme a senha"
                        className="password form-control  px-2 w-90"
                        required
                      />
                      <button
                        onClick={(event) => showConfirm(event)}
                        style={{
                          backgroundColor: "transparent",
                          borderTop: "1px solid #E0E0E0",
                          borderRight: "1px solid #E0E0E0",
                          borderBottom: "1px solid #E0E0E0",
                          borderLeft: "0px solid transparent",
                          borderRadius: "0px 5px 5px 0px",
                        }}
                      >
                        <img
                          alt=""
                          width={"24px"}
                          height={"24px"}
                          className=" w-auto"
                          src={showConfirmPassword ? EyeOpen : EyeBlock}
                        />
                      </button>
                    </div>
                  </div>
                </>
              )}

              <div className={`col-12 col-lg d-flex justify-content-end mt-5 mb-1`}>
                <button
                  onClick={(e) => setOpenDrawer(false)}
                  data-bs-dismiss="modal"
                  type="button"
                  className="bg-transparent border-1 me-4 rounded-2 fz-14 d-flex justify-content-center align-items-center ff-univanova-medium py-2 px-4 botton-cancel"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  onClick={(e) => handleUserSubmit(e)}
                  className="btn bg-gradient-theme-blue text-white rounded-2 fz-14 d-flex justify-content-center align-items-center ff-univanova-medium py-2 px-4"
                >
                  {user._id === undefined || user._id === null ? "Adicionar" : "Alterar"}{" "}
                </button>
              </div>
            </div>
          </form>
        </div>
      </form>
    </Drawer>
  );
};

export default NewReserveFoodDrawer;
